import { render, staticRenderFns } from "./ChannelSelect.vue?vue&type=template&id=0374b742&"
import script from "./ChannelSelect.vue?vue&type=script&lang=js&"
export * from "./ChannelSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports